import React, { FC } from 'react';
import { UserProfileLayoutBox } from 'src/user/common/components/UserProfileLayoutBox';
import { UserCoursesHeader } from 'src/user/courses/components/UserCoursesHeader';
import { UserCoursesUpcoming } from 'src/user/courses/components/UserCoursesUpcoming';
import { UserCoursesPast } from 'src/user/courses/components/UserCoursesPast';
import { UserCoursesContinueLearning } from 'src/user/courses/components/UserCoursesContinueLearning';
import { RouteComponentProps } from 'src/common/migration/RouteComponentProps';
import { WithUserModuleLayout } from 'src/user/UserModuleLayout';
import { VendorGetStaticProps } from 'vendor/utils/VendorGetStaticProps';

const CoursesPage: FC<RouteComponentProps> = () => (
  <WithUserModuleLayout>
    <UserProfileLayoutBox>
      <UserCoursesHeader />
      <UserCoursesUpcoming />
      <UserCoursesContinueLearning />
      <UserCoursesPast />
    </UserProfileLayoutBox>
  </WithUserModuleLayout>
);

export const getStaticProps = VendorGetStaticProps(() => ({
  props: {},
  revalidate: false,
}));

export default CoursesPage;
